"use client";
import React from "react";
import styled from "styled-components";
import { Col } from "react-bootstrap";
import { Img } from "@/components/Img";
import { Black } from "@/styles/globalStyleVars";
import Title from "@/components/Title";
import ThemeRow from "@/components/theme/row";
import reactHtmlParser from "react-html-parser";

const ServiceOverview = ({ data }) => {
  return (
    <StyledOverview className="service-overview pt-200 pb-200">
      {data?.bg_img && (
        <Img
          parallax
          parallaxSpeed={".5"}
          objectFit={"contain"}
          src={data?.bg_img}
          alt={data?.section_name}
        />
      )}

      {data?.section_name && (
        <ThemeRow>
          <Col sm={7}>
            <Title
              text={data?.section_name}
              version
              number={"I"}
              background={"#8C263D"}
            />
          </Col>
        </ThemeRow>
      )}

      <ThemeRow>
        <Col sm={10}>
          <div className="details fade-up">
            {data?.title && <h4>{reactHtmlParser(data?.title)}</h4>}

            {data?.desc && reactHtmlParser(data?.desc)}
          </div>
        </Col>
      </ThemeRow>
    </StyledOverview>
  );
};

const StyledOverview = styled.section`
  overflow: hidden;
  position: relative;

  img {
    object-fit: cover !important;
  }
    .title {
        p{
            margin-right: 10px;
        }
        h2 {
            padding: 0 !important;

            &:after , &:before{
                display: none !important;
            }
        }
    }

    
  //.title {
  //  h2 {
  //    padding-left: 45px;
  //
  //    &:before {
  //      left: 45px;
  //    }
  //  }
  //  &:after {
  //    bottom: -67px;
  //  }
  //}

  .details {
    padding-left: 88px;
  }

  h4 {
    margin-top: 80px;
    font-size: 32px;
    line-height: 36px;
    font-weight: 500;
    color: ${Black};
    margin-bottom: 40px;
  }

  @media (max-width: 767px) {
    .details {
      padding-left: 0;
    }

    .title {
      p {
        &:after {
        }
      }
    }

    h2 {
      padding-left: 0 !important;
    }

    h4 {
      font-size: 28px;
      line-height: 32px;
    }
  }
`;

export default ServiceOverview;
